<template>
  <div class="role">

    <el-button @click="showDialog('add')" class="add qjc-fts-16">添加商品</el-button>
    <el-table :data="list" style="width: 100%">
      <template slot="empty">
        <div class="empty-wrap">
          <el-image class="empty-img" :src="require('@/assets/images/empty-history.png')"></el-image>
          <div class="empty-text">暂无数据</div>
        </div>
      </template>
      <el-table-column label="编号" prop="id" min-width="60"></el-table-column>
      <el-table-column label="商品名称" prop="name" min-width="160"></el-table-column>
      <el-table-column label="商品图" width="80px" prop="img_url">
        <template slot-scope="scope">
          <div class="image-box">
            <el-image class="goods_img" v-if="scope.row.img_url" :src="scope.row.img_url"
              :preview-src-list="[scope.row.img_url]"></el-image>
            <div v-else>暂无图片</div>
          </div>

        </template>
      </el-table-column>

      <el-table-column label="市场价格" prop="cost_price"></el-table-column>
      <el-table-column label="商品售价" prop="price"></el-table-column>
      <el-table-column label="验血价格" prop="blood_price"></el-table-column>
      <el-table-column label="商品代码" prop="type">
        <template slot-scope="scope">
          {{ scope.row.type ? scope.row.type : '--' }}
        </template>
      </el-table-column>
      <el-table-column label="排序" prop="sort"></el-table-column>

      <el-table-column label="状态" prop="status">
        <template slot-scope="scope">
          <div v-if="scope.row.status == 1" class="order_status_80">已上架</div>
          <div v-else class="order_status_40">已下架</div>
        </template>
      </el-table-column>
      <el-table-column label="操作日期" prop="updated_at" min-width="160px">
        <template slot-scope="scope">
          <div class="">{{ scope.row.updated_at ? scope.row.updated_at : '--' }}</div>
        </template>
      </el-table-column>
      <el-table-column label="操作" prop="action" fixed="right" min-width="80">
        <template slot-scope="scope">
          <div class="table-action-btn">
            <el-button type="primary" size="small" class="editBtn"
              @click="showDialog('update', scope.row.id)">编辑</el-button>
          </div>
        </template>
      </el-table-column>

    </el-table>

    <!-- 分页 -->
    <el-pagination @current-change="pageChange" :current-page.sync="pager.page" hide-on-single-page
      :page-size="pager.pagesize" prev-text="上一页" next-text="下一页" layout="total, prev, pager, next,jumper"
      :total="pager.count">
    </el-pagination>


    <!-- 添加、修改弹窗 -->
    <el-dialog :close-on-click-modal="false" :title="(oper == 'add' ? '添加' : (oper == 'update' ? '修改' : '')) + '商品'"
      :visible.sync="isAlert" width="50%" :before-close="formCancel">
      <el-form :model="formData" :rules="rules" ref="form">
        <el-form-item label="商品名称" prop="name">
          <div class="code_cell">
            <el-input v-model.trim="formData.name" placeholder="请输入" :maxlength="20"></el-input>
          </div>
        </el-form-item>
        <el-form-item label="商品图" prop="goods_img">
          <div class="code_cell">
            <div class="file-input-box">
              <input class="file-input" type="file" name="file" accept="image/*" id="fileUpload"
                @change="handleFileImg" />
              <el-image v-if="hasImg" fit="cover" class="img-box" :src="formData.file_url"></el-image>
              <div class="close_icon_box" v-if="hasImg" @click="handleDelImg">
                <el-image class="close_icon" :src="require('@/assets/images/close_bg_icon.png')"></el-image>
              </div>
            </div>
            <div class="btn_cell">
              <el-button class="btn_ht" @click="handleOpenImg">图 库</el-button>
            </div>
          </div>
        </el-form-item>


        <el-form-item label="市场价格" prop="cost_price">
          <div class="code_cell">
            <el-input v-model.trim="formData.cost_price" type="number" placeholder="请输入"></el-input>
          </div>
        </el-form-item>
        <el-form-item label="商品售价" prop="price">
          <div class="code_cell">
            <el-input v-model.trim="formData.price" placeholder="请输入" type="number"></el-input>
          </div>
        </el-form-item>

        <el-form-item label="验血价格" prop="blood_price">
          <div class="code_cell">
            <el-input v-model.trim="formData.blood_price" type="number" placeholder="请输入"></el-input>
          </div>
        </el-form-item>
        <div class="custom_wrap" v-if="custom && custom.base">
          <div class="custom_item">
            <div class="custom_item_title">基础体检套餐</div>
            <div class="custom_item_cell">
              <div class="custom_item_label">名称</div>
              <div class="custom_item_val">
                <el-input class="custom_item_input" v-model.trim="base.name"></el-input>
              </div>
            </div>
            <div class="custom_item_cell">
              <div class="custom_item_label">价格</div>
              <div class="custom_item_val">
                <el-input class="custom_item_input" type="number" v-model.trim="base.price"
                  onkeyup="if(value===''){value=0};value=value.replace(/[^0-9.]/g,'');if(value>=99){value=99};if(String(value)==='0'){value=0}"></el-input>
              </div>
            </div>
          </div>
          <div class="custom_item">
            <div class="custom_item_title">增值包-通用健康评分</div>
            <div class="custom_item_cell">
              <div class="custom_item_label">名称</div>
              <div class="custom_item_val">
                <el-input class="" v-model.trim="mlev.name"></el-input>
              </div>
            </div>
            <div class="custom_item_cell">
              <div class="custom_item_label">价格</div>
              <div class="custom_item_val">
                <el-input class="custom_item_input" type="number" v-model.trim="mlev.price"
                  onkeyup="if(value===''){value=0};value=value.replace(/[^0-9.]/g,'');if(value>=99){value=99};if(String(value)==='0'){value=0}"></el-input>
              </div>
            </div>
          </div>
          <div class="custom_item">
            <div class="custom_item_title">增值包-同族群PLM对比</div>
            <div class="custom_item_cell">
              <div class="custom_item_label">名称</div>
              <div class="custom_item_val">
                <el-input class="" v-model.trim="packageA.name"></el-input>
              </div>
            </div>
            <div class="custom_item_cell">
              <div class="custom_item_label">价格</div>
              <div class="custom_item_val">
                <el-input class="custom_item_input" type="number" v-model.trim="packageA.price"
                  onkeyup="if(value===''){value=0};value=value.replace(/[^0-9.]/g,'');if(value>=99){value=99};if(String(value)==='0'){value=0}"></el-input>
              </div>
            </div>
          </div>
          <div class="custom_item">
            <div class="custom_item_title">增值包-共病风险</div>
            <div class="custom_item_cell">
              <div class="custom_item_label">名称</div>
              <div class="custom_item_val">
                <el-input class="" v-model.trim="packageB.name"></el-input>
              </div>
            </div>
            <div class="custom_item_cell">
              <div class="custom_item_label">价格</div>
              <div class="custom_item_val">
                <el-input class="custom_item_input" type="number" v-model.trim="packageB.price"
                  onkeyup="if(value===''){value=0};value=value.replace(/[^0-9.]/g,'');if(value>=99){value=99};if(String(value)==='0'){value=0}"></el-input>
              </div>
            </div>
          </div>
          <div class="custom_item">
            <div class="custom_item_title">增值包-疾病风险远期预测</div>
            <div class="custom_item_cell">
              <div class="custom_item_label">名称</div>
              <div class="custom_item_val">
                <el-input class="" v-model.trim="packageC.name"></el-input>
              </div>
            </div>
            <div class="custom_item_cell">
              <div class="custom_item_label">价格</div>
              <div class="custom_item_val">
                <el-input class="custom_item_input" type="number" v-model.trim="packageC.price"
                  onkeyup="if(value===''){value=0};value=value.replace(/[^0-9.]/g,'');if(value>=99){value=99};if(String(value)==='0'){value=0}"></el-input>
              </div>
            </div>
          </div>
          <div class="custom_item">
            <div class="custom_item_title">增值包-健康促进方案</div>
            <div class="custom_item_cell">
              <div class="custom_item_label">名称</div>
              <div class="custom_item_val">
                <el-input class="" v-model.trim="packageD.name"></el-input>
              </div>
            </div>
            <div class="custom_item_cell">
              <div class="custom_item_label">价格</div>
              <div class="custom_item_val">
                <el-input class="custom_item_input" type="number" v-model.trim="packageD.price"
                  onkeyup="if(value===''){value=0};value=value.replace(/[^0-9.]/g,'');if(value>=99){value=99};if(String(value)==='0'){value=0}"></el-input>
              </div>
            </div>
          </div>
          <div class="custom_item">
            <div class="custom_item_title">增值包-骨折风险评估</div>
            <div class="custom_item_cell">
              <div class="custom_item_label">名称</div>
              <div class="custom_item_val">
                <el-input class="" v-model.trim="packageFB.name"></el-input>
              </div>
            </div>
            <div class="custom_item_cell">
              <div class="custom_item_label">价格</div>
              <div class="custom_item_val">
                <el-input class="custom_item_input" type="number" v-model.trim="packageFB.price"
                  onkeyup="if(value===''){value=0};value=value.replace(/[^0-9.]/g,'');if(value>=99){value=99};if(String(value)==='0'){value=0}"></el-input>
              </div>
            </div>
          </div>
        </div>



        <el-form-item label="商品代码" prop="type">
          <div class="code_cell">
            <el-input v-model.trim="formData.type" type="text" placeholder="请输入"></el-input>
          </div>
        </el-form-item>

        <el-form-item label="排序" prop="sort">
          <div class="code_cell">
            <el-input v-model.trim="formData.sort" type="number" placeholder="请输入"></el-input>
          </div>
        </el-form-item>
        <el-form-item label="状态" prop="status">
          <el-switch v-model="formData.status" active-color="#38E019" inactive-color="#FF5219">
          </el-switch>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button class="cancel-btn" @click="formCancel">取消</el-button>
        <el-button class="submit-btn" @click="formSubmit">提交</el-button>
      </span>
    </el-dialog>
    <el-dialog :close-on-click-modal="false" title="图片" :visible.sync="isAlert3" width="50%">
      <div class="ht_list">
        <div class="ht_item" v-for="(item, index) in imgList" :key="index">
          <el-image class="ht_img" fit="cover" :src="item.file_url" @click="handleImgItem(item)"></el-image>
          <div class="ht_item_id">{{ item.id }}</div>
        </div>
      </div>
      <el-pagination @current-change="pageChange2" :current-page.sync="pager2.page" hide-on-single-page
        :page-size="pager2.pagesize" prev-text="上一页" next-text="下一页" layout="total, prev, pager, next,jumper"
        :total="pager2.count">
      </el-pagination>
    </el-dialog>

  </div>
</template>

<script>
import { Base64 } from 'js-base64';
import { getGoods, uploadImg, getImgList } from '@/utils/axios.js';

export default {
  name: 'mainPackage',
  data () {
    var powerVerify = (rule, value, callback) => {
      if (this.noTimes) {
        callback();
      } else if (!this.noTimes && this.formData.times <= 0) {
        callback(new Error('请输入有效次数'));
      }
      callback();
    }
    var packageVerify = (rule, value, callback) => {
      if (this.formData.goods_ids.length <= 0) {
        callback(new Error('请选择使用产品'));
      } else {
        callback();
      }
      // callback();
    }
    return {
      submiting: false, // 正在请求
      list: [], //列表
      pager: {
        count: 0, // 总条数
        page: 1, // 当前页
        pagecount: 0, // 总页数
        pagesize: 10 // 每页条数
      },
      pager2: {
        count: 0, // 总条数
        page: 1, // 当前页
        pagecount: 0, // 总页数
        pagesize: 10 // 每页条数
      },
      isAlert: false,
      oper: '',
      formData: {
        name: '',
        cost_price: '',
        price: '',
        blood_price: '',
        sort: 100,
        custom: '',
        type: '',
        status: true,
        file_url: '',
      },
      rules: {
        name: [
          { required: true, message: '请输入名称', trigger: 'blur' }
        ],
        cost_price: [
          { required: true, message: '请输入市场价格', trigger: 'blur' }
        ],
        price: [
          { required: true, message: '请输入价格', trigger: 'blur' }
          // { validator: packageVerify, trigger: 'change' }
        ],
        blood_price: [
          { required: false, message: '请输入验血价格', trigger: 'blur' }
        ],
        file_url: [
          { required: false, message: '请上传商品图片', trigger: 'blur' }
        ],
        type: [
          { required: true, message: '请输入代码', trigger: 'blur' }
        ],
        sort: [
          { required: false, message: '请输入排序', trigger: 'blur' }
        ],
        status: [
          { required: false, message: '请选择启用状态', trigger: 'change' }
        ],
      },
      rules1: {
        name: [
          { required: true, message: '请输入名称', trigger: 'blur' }
        ],
        price: [
          { required: true, message: '请输入价格', trigger: 'blur' }
          // { validator: packageVerify, trigger: 'change' }
        ],
      },
      custom: '',
      base: {},
      mlev: {},
      packageA: {},
      packageB: {},
      packageC: {},
      packageD: {},
      packageFB: {},
      imgFile: '',
      file_url: '',
      isAlert3: false,
      file_id: '0',
      imgList: [],
      hasImg: false
    };
  },

  mounted () {
    this.getList();
  },
  components: {},
  watch: {
    'formData.name': {
      handler (val) {
        if (val) {
          this.formData.name = val.replace(/\s+/g, "")
        }

      },
      deep: true,
      immediate: true
    },
    'formData.type': {
      handler (val) {
        if (val) {
          this.formData.type = val.replace(/\s+/g, "")
        }

      },
      deep: true,
      immediate: true
    },
  },
  methods: {
    handleImgItem (item) {
      this.imgFile = '';
      this.file_id = item.id
      this.file_url = item.file_url
      this.formData.file_url = item.file_url
      this.formData.img = item.id
      this.imgFile = ''
      this.hasImg = true
      this.isAlert3 = false
    },

    handleFileImg (e) {
      let file = e.target.files[0]
      if (file) {
        this.imgFile = e.target.files[0]
        this.file_url = window.URL.createObjectURL(file)
        this.formData.file_url = window.URL.createObjectURL(file)
        this.hasImg = true
      }
      document.querySelector("#fileUpload").setAttribute('type', 'text');
      document.querySelector("#fileUpload").setAttribute('type', 'file')
    },
    handleDelImg () {
      this.file_id = '0';
      this.imgFile = '';
      this.file_url = '';
      this.formData.file_url = '';
      this.formData.img = '0';
      this.hasImg = false
    },
    handleOpenImg () {
      this.isAlert3 = true
      this.handleImgList()
    },
    handleImgList () {
      getImgList(this.pager2).then((res) => {
        if (res.code == 200) {
          let result = JSON.parse(window.atob(res.data))
          this.imgList = result.data
          this.pager2 = result.pager;

          // 数值可能为字符串，需转换为number
          for (var key in this.pager2) {
            this.pager2[key] = parseInt(this.pager2[key]);
          }
        }
      })
    },
    handleStatus (val) {
      getGoods({ act: 'status', id: val.id, status: val.status }).then((res) => {
        if (res.code == 200) {
          this.getList();
        } else {
          this.$myAlert({
            type: 'fail',
            title: res.msg
          });
        }
      })
    },
    // 获取列表
    getList () {
      getGoods(this.pager).then(res => {
        if (res.code == 200) {
          const result = JSON.parse(Base64.decode(res.data))
          this.list = result.data;
          this.pager = result.pager;
          console.log("result", result);

          this.list.map((item) => {

          })
          // 数值可能为字符串，需转换为number
          for (var key in this.pager) {
            this.pager[key] = parseInt(this.pager[key]);
          }

        } else {
          this.$myAlert({
            type: 'fail',
            title: res.msg
          });
        }
      });
    },
    pageChange (page) {
      this.pager.page = page;
      this.getList();
    },
    pageChange2 (page) {
      this.pager2.page = page;
      this.handleImgList();
    },
    showDialog (oper, id) {
      this.oper = oper;
      this.hasImg = false
      this.isAlert = true;
      if (oper == 'update') {
        getGoods({ act: 'detail', id: id }).then((res) => {
          if (res.code == 200) {
            const result = JSON.parse(Base64.decode(res.data))
            if (result.img_url) {
              this.hasImg = true
            }
            this.formData = {
              id: result.id,
              name: result.name,
              cost_price: result.cost_price,
              custom: result.custom ? { ...result.custom } : '',
              price: result.price,
              blood_price: result.blood_price,
              sort: result.sort,
              type: result.type,
              status: result.status == 1 ? true : false,
              img: result.img,
              file_url: result.img_url
            }

            if (result.custom) {
              this.custom = result.custom
              this.base = result.custom.base
              this.mlev = result.custom.mlev
              this.packageA = result.custom.packageA
              this.packageB = result.custom.packageB
              this.packageC = result.custom.packageC
              this.packageD = result.custom.packageD
              this.packageFB = result.custom.packageFB
            } else {
              this.custom = ''
            }



          } else {
            this.$myAlert({
              type: 'fail',
              title: res.msg
            });
          }
        })
      } else {
        this.custom = {};
      }

    },
    formSubmit () {
      if (this.oper == 'update') {
        this.$refs.form.validate(isSuc => {
          if (isSuc) {
            let data = { ...this.formData };
            data.act = 'update';
            data.status = data.status ? '1' : '0';

            if (!this.custom) {
              delete data.custom
            }
            if (this.imgFile) {
              let formData2 = new FormData();
              formData2.append('file', this.imgFile)
              uploadImg(formData2).then((res) => {
                if (res.code == 200) {
                  this.file_url = res.file_url;
                  data.img = res.file_id;

                  this.handleGetGoodsM(data)
                } else {
                  this.$myAlert({
                    type: 'fail',
                    title: res.msg
                  });
                }
              })
            } else {
              this.handleGetGoodsM(data)
            }
          }

        })
      } else if (this.oper == 'add') {
        this.$refs.form.validate(isSuc => {
          if (isSuc) {
            let data = { ...this.formData };
            data.act = 'add';
            data.status = data.status ? '1' : '0';

            if (!this.custom) {
              delete data.custom
            }
            data.file_id = '0';
            if (this.imgFile) {
              let formData = new FormData();
              formData.append('file', this.imgFile)
              uploadImg(formData).then((res) => {
                if (res.code == 200) {
                  this.file_url = res.file_url;
                  data.img = res.file_id;

                  this.handleGetGoodsM(data)
                } else {
                  this.$myAlert({
                    type: 'fail',
                    title: res.msg
                  });
                  return
                }
              })
            } else {
              this.handleGetGoodsM(data)
            }
          }
        })
      }
    },
    handleGetGoodsM (data) {
      // return
      getGoods(data).then((res) => {
        if (res.code == 200) {
          this.isAlert = false;
          this.formData = {};
          this.$myAlert({
            type: 'success',
            title: (this.oper == 'add' ? '添加' : '修改') + '成功'
          });
          this.getList();
        } else {
          this.$myAlert({
            type: 'fail',
            title: res.msg
          });
        }
      })
    },
    formCancel () {
      this.file_id = '0';
      this.imgFile = '';
      this.file_url = '';
      this.formData.file_url = '';
      this.formData.img = '0';
      this.$refs.form.resetFields();
      this.noTimes = false;
      this.isAlert = false;
      this.hasImg = false
    },

  }
};
</script>

<style scoped>
.role>>>.el-icon-circle-close {
  color: #fff !important;
}

.el-dialog .el-form .el-form-item>>>.code_cell .el-input__inner {
  padding-right: 80px !important;
}

.el-dialog .el-form .el-form-item>>>.el-date-editor.el-input,
.el-dialog .el-form .el-form-item>>>.el-date-editor.el-input__inner {
  width: 100%;
}

.el-dialog .el-form .el-form-item>>>.el-select {
  width: 100%;
}



.el-dialog .el-form>>>.el-form-item__label {
  width: 19%;
  padding-right: 24px;
  margin-left: 4%;
  text-align: right;
}

.el-dialog .el-form>>>.el-form-item__content {
  float: left;
  width: 60%;
  margin-right: 0;
}

.right-wrap>>>.el-checkbox__input.is-checked+.el-checkbox__label {
  color: #6681FA;
}

.right-wrap>>>.el-checkbox__input.is-checked .el-checkbox__inner,
.el-checkbox__input.is-indeterminate .el-checkbox__inner {
  background-color: #6681FA;
  border-color: #6681FA;
}

.right-wrap>>>.el-switch__core:after {
  background-color: #828DBC;
}

.right-wrap>>>.el-switch.is-checked .el-switch__core::after {
  background-color: #6681FA;
}

.right-wrap>>>.el-input-number__increase {
  display: none;
}

.right-wrap>>>.el-input-number__decrease {
  display: none;
}

.right-wrap .input-number>>>.el-input__inner {
  height: 30px;
  border: none;
  border-bottom: 1px solid #CED4F0;
  border-radius: 0;
  padding: 0;
  margin-left: 10px;
}

::v-deep input::-webkit-outer-spin-button,
::v-deep input::-webkit-inner-spin-button {
  -webkit-appearance: none !important;
}

::v-deep input[type='number'] {
  line-height: 1;
  -moz-appearance: textfield !important;
}
</style>
<style lang="scss" scoped>
.role {
  // display: flex;
  width: 100%;
  height: 100%;
  padding: 28px 24px;
  padding-top: 0;

  .left-menus {
    min-width: 170px;
    width: 170px;
    padding: 30px 24px;
    border-right: 1px solid #E5E8F5;
    background-color: #ffffff;

    .add-action {
      display: flex;
      align-items: center;
      cursor: pointer;

      .add-action-img {
        display: flex;
        align-items: center;
        align-items: center;
        width: 24px;
        height: 24px;
        background-color: #6883FB;
        border-radius: 50%;

        &::after {
          content: "+";
          width: 100%;
          font-size: 20px;
          color: #fff;
          text-align: center;
          margin-bottom: 4px;
        }
      }

      .add-action-text {
        font-size: 14px;
        color: #6883FB;
        margin-left: 8px;
      }
    }

    .left-list {
      padding-top: 20px;
    }

    .left-enp-item {
      padding: 12px 0;
      font-size: 15px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #525866;
      line-height: 20px;
      cursor: pointer;
    }

    .left-enp-item-active {
      padding: 12px 0;
      font-size: 15px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 500;
      color: #6883FB;
      line-height: 20px;
    }
  }

  .right-wrap {
    flex: 1;
    padding: 36px 24px;
    overflow: auto;

    .right-temp {
      margin-bottom: 32px;

      .temp-title {
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-size: 18px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #293033;
        line-height: 24px;
        padding-bottom: 10px;
        border-bottom: 1px solid #E5E8F5;
      }

      .temp-info {
        margin-top: 12px;
      }
    }

    .submit-btn {
      width: 94px;
      height: 34px;
      font-size: 15px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #FFFFFF;
      line-height: 34px;
      background-color: #6883FB;
      border-radius: 17px;
      border: none;
      margin-top: 10px;
    }

    .info-cell {
      margin-bottom: 20px;
    }

    .input-number {
      width: 50px;
    }

    .custom-info {
      position: relative;
      width: 670px;
      padding: 24px;
      border: 1px solid #CED4F0;
      border-radius: 4px;
      margin-top: 10px;

      &::before {
        box-sizing: content-box;
        position: absolute;
        width: 0;
        height: 0;
        top: -16px;
        left: 41px;
        padding: 0;
        border-top: 8px solid transparent;
        border-left: 8px solid transparent;
        border-right: 8px solid transparent;
        border-bottom: 8px solid #fff;
        display: block;
        content: '';
        z-index: 12;
      }

      &::after {
        box-sizing: content-box;
        position: absolute;
        width: 0;
        height: 0;
        top: -18px;
        left: 40px;
        padding: 0;
        border-top: 9px solid transparent;
        border-left: 9px solid transparent;
        border-right: 9px solid transparent;
        border-bottom: 9px solid #CED4F0;
        display: block;
        content: '';
        z-index: 10;
      }
    }

    .custom-group {
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;

      .custom-item {
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 30%;
        margin-right: 20px;
      }
    }
  }

  .add {
    padding: 8px 12px;
    margin: 24px 0 12px;
    color: #fff;
  }

  .el-table {
    i[class^=el-icon] {
      margin-right: 16px;
      cursor: pointer;
    }
  }

  .el-pagination {
    text-align: center;
    margin-top: 32px;
  }

  .el-dialog {

    .dialog-title {
      font-size: 18px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #293033;
      text-align: center;
    }

    .all-power {
      -webkit-appearance: none;
      background-color: #FFF;
      background-image: none;
      border-radius: 4px;
      border: 1px solid #DCDFE6;
      box-sizing: border-box;
      color: #606266;
      display: inline-block;
      font-size: inherit;
      height: 40px;
      line-height: 40px;
      outline: 0;
      padding: 0 15px;
      transition: border-color .2s cubic-bezier(.645, .045, .355, 1);
      width: 100%;
    }

    .dialog-footer {
      display: flex;
      align-items: center;
      justify-content: center;

      .cancel-btn {
        width: 94px;
        height: 34px;
        font-size: 14px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #6883FB;
        border: 1px solid #6883FB;
        border-radius: 17px;
        background-color: #fff;
      }

      .submit-btn {
        width: 94px;
        height: 34px;
        font-size: 14px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #fff;
        border: none;
        border-radius: 17px;
        background-color: #6883FB;
        margin-left: 16px;
      }

      .el-button {
        padding: 9px 15px;
      }
    }
  }
}

.quota_cell {
  position: relative;
  display: flex;
  align-items: center;

  .unit {
    position: absolute;
    right: 10px;
    top: 0px;
  }
}

.times_cell {
  display: flex;
  align-items: center;

  .noTimes {
    height: 40px;
    padding: 0 12px;
    margin-left: 10px;
    border: 1px solid #DCDFE6;
    border-radius: 4px;
  }

  .active {
    border: 1px solid #6681FA;
  }
}

.empty-wrap {
  padding: 100px 0;
}

.empty-img {
  width: 338px;
  height: 218px;
}


.el-icon-edit {
  color: #6681FA;
}


.custom_title {
  font-size: 15px;
  margin: 20px 0;
  padding-left: 120px;
}

.custom_wrap {
  display: flex;
  align-items: center;
  // justify-content: space-between;
  flex-wrap: wrap;
  flex-direction: row;
  padding: 0 52px;
  margin-bottom: 20px;

  .custom_item {
    width: 46%;
    margin-bottom: 10px;

    &:nth-child(2n) {
      width: 42%;
      position: relative;
      left: -34px;
    }

    .custom_item_title {
      font-size: 15px;
      padding-left: 100px;
      margin-bottom: 10px;
      margin-top: 10px;
    }
  }
}

.custom_item_cell {
  display: flex;
  align-items: center;
  // justify-content: center;
  width: 100%;
  margin-bottom: 8px;

  .custom_item_label {
    width: 28%;
    padding: 0 12px 0 0;
    padding-right: 24px;
    margin-left: 4%;
    text-align: right;
    font-size: 14px;
    color: #606266;
    line-height: 40px;
  }

  .custom_item_val {
    width: 60%;
  }
}

.file-input-box {
  position: relative;
  width: 132px;
  height: 132px;
  border: 1px solid #D5D8DE;
  cursor: pointer;
}

.file-input {
  position: absolute;
  width: 128px;
  height: 128px;
  opacity: 0;
  z-index: 11;
}

.file-input-del {
  padding-left: 18px;
  line-height: 20px;
  margin-top: -10px;
}

.file-input-del span {
  cursor: pointer;
}

.img-box {
  width: 128px;
  height: 128px;
  z-index: 9;
}

.img-box {
  img {
    width: 128px;
    height: 128px;
  }
}

.file-input-box {
  padding-bottom: 6px;

  &::after {
    position: absolute;
    top: -4px;
    content: '+';
    font-size: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    cursor: pointer;
    z-index: 2;
  }
}

.close_icon_box {
  position: absolute;
  top: 0;
  right: 0;
  width: 40px;
  height: 40px;
  z-index: 11;

  &::after {
    position: absolute;
    content: '';
    right: 0;
    top: 0;
    width: 20px;
    height: 20px;
    background-color: #fff;
    z-index: 9;
  }
}

.close_icon {
  position: absolute;
  width: 40px;
  height: 40px;
  transform: rotate(-90deg);
  z-index: 13;
}

.btn_ht {
  width: 130px;
  height: 40px;
  margin-top: 10px;
}

.ht_list {
  display: flex;
  align-items: center;
  flex-direction: row;
  flex-wrap: wrap;
}

.ht_item {
  width: 1.18rem;
  height: 1.18rem;
  margin-right: 0.2rem;
  margin-bottom: 40px;

  &:nth-child(5n) {
    margin-right: 0;
  }
}

.ht_img {
  width: 1.18rem;
  height: 1.18rem;
}

.ht_item_id {
  margin-top: 10px;
  text-align: center;
}


.image-box {
  width: 50px;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;

  border: 1px solid #6681FA;

  font-size: 10px;

  .goods_img {
    width: 100%;
  }
}

.table-action-btn {
  >div {
    cursor: pointer;
    color: #6683fb;
  }
}
</style>